// extracted by mini-css-extract-plugin
module.exports = {"charts":"BottomPanel_charts__nlYpY","container":"BottomPanel_container__8Ibg_","containerInner":"BottomPanel_containerInner__X_CRo","similar":"BottomPanel_similar__h_0l2"};